<template>
  <!-- Scales with font-size; color comes from CSS (Vuetify) -->

  <svg
    viewBox="0 0 500 442"
    width="28"
    style="display:inline-block; vertical-align:middle; fill: currentColor;"
  >
    <g transform="translate(0.000000,442.000000) scale(0.100000,-0.100000)">
<path d="M1585 4199 c-104 -13 -248 -62 -340 -117 -157 -91 -297 -256 -368
-433 -52 -131 -58 -170 -65 -434 l-7 -250 -130 -6 c-97 -4 -142 -11 -178 -25
-75 -31 -141 -94 -179 -171 l-33 -68 -3 -955 c-3 -1006 -3 -1001 42 -1082 25
-45 83 -108 99 -108 7 0 28 15 47 33 19 18 85 75 145 127 61 52 112 97 115
101 5 5 120 104 380 328 74 64 140 120 146 126 6 6 54 48 107 94 54 46 97 86
97 88 0 2 -17 27 -39 56 -55 75 -71 124 -71 218 0 67 5 90 29 142 65 140 187
213 340 205 95 -5 168 -37 231 -102 24 -25 48 -46 53 -46 7 0 118 91 147 120
4 4 75 65 157 135 13 11 45 39 70 63 26 23 51 42 56 42 5 0 -1 -8 -14 -19 -13
-10 -42 -36 -65 -57 -42 -40 -59 -56 -179 -159 -71 -61 -84 -73 -165 -149
-121 -113 -516 -455 -584 -506 -31 -22 -63 -52 -72 -66 -10 -14 -30 -32 -45
-40 -16 -8 -53 -38 -82 -67 -30 -28 -70 -63 -90 -77 -20 -14 -38 -32 -40 -42
-3 -9 -20 -24 -38 -33 -19 -10 -56 -41 -84 -70 -27 -28 -61 -57 -75 -64 -14
-6 -35 -27 -47 -45 -11 -18 -36 -40 -55 -49 -42 -21 -68 -42 -68 -54 0 -18
-58 -65 -71 -58 -8 5 -10 4 -5 -3 4 -7 1 -12 -6 -12 -15 0 -48 -34 -48 -49 0
-13 -76 -72 -83 -65 -7 7 -37 -20 -37 -34 0 -9 -22 -30 -144 -140 -35 -32 -45
-47 -37 -55 8 -8 15 -6 28 5 10 8 122 107 248 218 127 111 237 205 246 209 21
8 72 53 84 75 6 9 24 25 40 34 17 9 52 39 79 67 27 27 68 62 90 77 22 15 45
35 50 46 9 15 104 101 311 281 11 9 38 30 60 46 22 17 78 66 125 111 47 45
105 99 130 120 25 21 90 79 146 129 182 163 247 219 301 261 29 23 90 75 135
116 46 41 101 90 123 109 49 42 42 35 161 145 54 51 196 176 314 279 268 233
247 212 233 226 -8 8 -30 -5 -84 -51 -66 -57 -73 -61 -80 -43 -9 25 -81 84
-134 108 -31 15 -72 21 -175 25 l-135 5 -6 245 c-6 262 -16 322 -72 455 -121
287 -391 493 -700 535 -89 11 -132 11 -232 -1z m255 -368 c36 -10 88 -30 117
-45 69 -36 174 -143 212 -215 53 -102 61 -156 61 -395 l0 -216 -530 0 -530 0
0 218 c0 184 3 227 19 285 55 192 227 348 421 380 65 11 170 6 230 -12z m911
-1284 c-10 -9 -11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z m-81 -71 c0 -2
-7 -7 -16 -10 -8 -3 -12 -2 -9 4 6 10 25 14 25 6z m-145 -125 c-3 -6 -11 -11
-16 -11 -5 0 -4 6 3 14 14 16 24 13 13 -3z m-25 -25 c0 -2 -7 -7 -16 -10 -8
-3 -12 -2 -9 4 6 10 25 14 25 6z"/>
<path d="M2622 2363 c-48 -43 -92 -82 -98 -88 -13 -11 -45 -40 -159 -140 -44
-38 -92 -82 -108 -97 l-27 -28 2 -672 3 -673 390 0 c445 0 456 2 547 84 105
94 128 166 128 398 0 149 -3 180 -20 227 -25 66 -83 127 -145 153 -51 21 -53
33 -6 46 19 5 56 31 86 61 74 74 85 117 85 333 0 220 -16 276 -106 367 -85 85
-154 106 -355 106 l-129 0 -88 -77z m318 -458 l0 -175 -172 2 -173 3 -3 173
-2 172 175 0 175 0 0 -175z m0 -710 l0 -175 -175 0 -175 0 0 175 0 175 175 0
175 0 0 -175z"/>
<path d="M3898 2420 c-99 -37 -155 -88 -206 -183 l-27 -52 0 -630 0 -630 26
-56 c51 -108 151 -181 272 -200 40 -6 158 -9 276 -7 l206 3 66 31 c78 37 140
98 177 174 25 51 27 64 27 190 l0 135 -172 3 -173 2 0 -90 0 -90 -180 0 -180
0 0 530 0 530 180 0 180 0 0 -85 0 -85 175 0 175 0 0 117 c0 158 -22 224 -102
305 -44 45 -92 73 -167 97 -21 7 -123 11 -270 10 -201 -1 -243 -4 -283 -19z"/>
<path d="M1835 1664 c-16 -14 -44 -38 -60 -52 -17 -15 -66 -58 -110 -97 -43
-38 -94 -84 -112 -100 l-33 -30 2 -360 3 -360 175 0 175 0 3 513 c1 281 -1
512 -5 512 -5 0 -21 -12 -38 -26z"/>
<path d="M1135 1048 c-11 -11 -86 -79 -168 -151 -81 -71 -150 -140 -153 -152
-3 -13 -4 -36 -2 -51 l3 -29 175 0 175 0 3 194 c1 107 -1 198 -5 202 -5 4 -17
-2 -28 -13z"/>
                      </g>
                    </svg>
</template>
